module.exports = __webpack_public_path__ + "img/kll.ef2dad5f.jpg";